angular.module('core')
    .service('dblDateBucketService', ['translateFilter', 'moment', function(translateFilter, moment) {
        /**
         * Return date bucket object based on
         * how distant the date was prior to the reference date.
         *
         * The passed in referenceDate and date can be any representation that momentjs can handle.
         *
         * The returned date bucket has a name like "This Week", "Week of 12/01/2016", etc.,
         * and a weeksAgo field that can be used to for sorting.
         **/
        this.buildDateBucket = function (referenceDate, date) {
            var startOfReferenceWeek = moment(referenceDate).startOf('week');
            var startOfDateWeek = moment(date).startOf('week');
            var weeksAgo = startOfReferenceWeek.diff(startOfDateWeek, 'weeks');
            var bucketName;

            if (weeksAgo === 0) {
                bucketName = translateFilter('assignments.thisWeek');
            } else if (weeksAgo < 4) {
                bucketName = translateFilter('assignments.weekOf', { date: startOfDateWeek.format('L') });
            } else {
                bucketName = translateFilter('assignments.monthOf', { date: moment(date).format('MMMM YYYY') });
            }

            var dateBucket = {
                name: bucketName,
                weeksAgo: weeksAgo
            };

            return dateBucket;
        };
    }]
);
